import { RenewalDiscount } from "./renewal-discount";

export class RenewalDates {
    contractExpire: string;
    renewalStartDate: string;
    renewalFinalDate: string;
  
    constructor(renewalDates: any) {
      this.contractExpire = new Date(renewalDates.contractExpire).toLocaleDateString('pt-br');
      this.renewalStartDate = new Date(renewalDates.renewalStartDate).toLocaleDateString('pt-br');
      this.renewalFinalDate = new Date(renewalDates.renewalFinalDate).toLocaleDateString('pt-br');
    }

  }